import { c as _c } from "react/compiler-runtime";
import ChartCard from '../../components/ChartCard/ChartCard';
import { useCurrentClient } from 'shared/context/ClientContext';
import { mapMarkdownTableToChartCardProps } from 'shared/copilot/tables/mapMarkdownTableToChartCardProps';
import { type CopilotTableData } from 'shared/copilot/tables/types';
import { MarkdownTable, MarkdownTableBody, MarkdownTableDataCell, MarkdownTableHead, MarkdownTableHeaderCell, MarkdownTableRow } from 'shared/markdown/components/MarkdownTable';
import { renderInlineMarkdown } from 'shared/markdown/renderInlineMarkdown';
import { useMemo, type ReactElement } from 'react';
interface CopilotTableCardProps {
  table: CopilotTableData;
  variant?: 'compact' | 'standard';
}
const CopilotFallbackTable = t0 => {
  const $ = _c(19);
  const {
    table,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "compact" : t1;
  let t2;
  if ($[0] !== table.headers || $[1] !== variant) {
    let t3;
    if ($[3] !== variant) {
      t3 = header => <MarkdownTableHeaderCell key={header} variant={variant}>{renderInlineMarkdown(header, {
          variant
        })}</MarkdownTableHeaderCell>;
      $[3] = variant;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = table.headers.map(t3);
    $[0] = table.headers;
    $[1] = variant;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <MarkdownTableHead><MarkdownTableRow>{t2}</MarkdownTableRow></MarkdownTableHead>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== table.rows || $[8] !== table.sourceTableId || $[9] !== variant) {
    let t5;
    if ($[11] !== table.sourceTableId || $[12] !== variant) {
      t5 = (row, rowIndex) => <MarkdownTableRow key={`${table.sourceTableId}-${rowIndex}`}>{row.map((cell, cellIndex) => <MarkdownTableDataCell key={`${table.sourceTableId}-${rowIndex}-${cellIndex}`} variant={variant}>{renderInlineMarkdown(cell, {
            variant
          })}</MarkdownTableDataCell>)}</MarkdownTableRow>;
      $[11] = table.sourceTableId;
      $[12] = variant;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    t4 = table.rows.map(t5);
    $[7] = table.rows;
    $[8] = table.sourceTableId;
    $[9] = variant;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <MarkdownTableBody>{t4}</MarkdownTableBody>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <MarkdownTable>{t3}{t5}</MarkdownTable>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
const CopilotTableCard = t0 => {
  const $ = _c(8);
  const {
    table,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "compact" : t1;
  const {
    currentClient
  } = useCurrentClient();
  let t2;
  if ($[0] !== currentClient.currency || $[1] !== table) {
    t2 = mapMarkdownTableToChartCardProps(table, {
      currencyCode: currentClient.currency
    });
    $[0] = currentClient.currency;
    $[1] = table;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const chartCardProps = t2;
  if (chartCardProps == null) {
    let t3;
    if ($[3] !== table || $[4] !== variant) {
      t3 = <CopilotFallbackTable table={table} variant={variant} />;
      $[3] = table;
      $[4] = variant;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== chartCardProps) {
    t3 = <ChartCard {...chartCardProps} />;
    $[6] = chartCardProps;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default CopilotTableCard;